import { api } from './authService';

// Product service (D1-backed API)
const productService = {
  // Get products with filters and pagination
  getProducts: (params = {}) => {
    return api.get('/api/products', { params });
  },

  // Get single product by id or SKU (server supports both)
  getProduct: (idOrSku) => {
    return api.get(`/api/products/${idOrSku}`);
  },

  // Check product price for specific quantity
  checkPrice: (data) => {
    return api.post('/api/products/price-check', data);
  },

  // Get product categories
  getCategories: () => {
    return api.get('/api/products/categories/list');
  },

  // Get filter options
  getFilterOptions: () => {
    return api.get('/api/products/filters/options');
  },

  // Search products
  searchProducts: (searchTerm, filters = {}) => {
    return api.get('/api/products', {
      params: {
        search: searchTerm,
        ...filters,
      },
    });
  },

  // Get products by category
  getProductsByCategory: (categoryId, params = {}) => {
    return api.get('/api/products', {
      params: {
        category: categoryId,
        ...params,
      },
    });
  },

  // Get featured products
  getFeaturedProducts: (limit = 8) => {
    return api.get('/api/products', {
      params: {
        featured: true,
        limit,
      },
    });
  },

  // Get best sellers
  getBestSellers: (limit = 8) => {
    return api.get('/api/products', {
      params: {
        sortBy: 'salesCount',
        sortOrder: 'desc',
        limit,
      },
    });
  },

  // Get new arrivals
  getNewArrivals: (limit = 8) => {
    return api.get('/api/products', {
      params: {
        sortBy: 'createdAt',
        sortOrder: 'desc',
        limit,
      },
    });
  },

  // Get related products
  getRelatedProducts: (idOrSku, limit = 4) => {
    return api.get(`/api/products/${idOrSku}/related`, {
      params: { limit },
    });
  },

  // Reviews: get product reviews
  getReviews: (slug, params = {}) => {
    return api.get(`/api/products/${slug}/reviews`, { params });
  },

  // Reviews: add review/comment
  addReview: (
    slug,
    { rating, comment, parentId, photos, title, pros, cons }
  ) => {
    return api.post(`/api/products/${slug}/reviews`, {
      rating,
      comment,
      parentId,
      photos,
      title,
      pros,
      cons,
    });
  },

  // Admin: Create product
  createProduct: (productData) => {
    return api.post('/api/products', productData);
  },

  // Admin: Update product
  updateProduct: (productId, productData) => {
    return api.put(`/api/products/${productId}`, productData);
  },

  // Admin: Delete product
  deleteProduct: (productId) => {
    return api.delete(`/api/products/${productId}`);
  },

  // Admin: Upload product images
  uploadProductImages: (productId, formData) => {
    return api.post(`/api/products/${productId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default productService;
